import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';

export const SearchListingHit = ({ hit }: HitProps) => {
  return (
    <div>
      <HitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" />
      </HitHeadline>
      <Snippet
        hit={hit}
        attribute="body"
        className={classnames('line-clamp-4', 'md:line-clamp-2', 'text-black')}
      />
    </div>
  );
};
